module.exports = __webpack_public_path__ + "static/media/undraw_studying_s3l7.91a796c1.svg";